import axios from "axios";
import { Empty } from "components/Empty";
import { FabricItem } from "components/FabricItem";
import { useOrderSample } from "hooks/useOrderSample";
import { useState, useEffect } from "react";

const RecentlyViewed = ({showNotification}) => {
    const [isLoading, setIsLoading] = useState(false)
    const [items, setItems] = useState([])

    const { orderSample, modalData, setModalData } = useOrderSample(setItems, async (fabricId) => {
        const item = document.querySelector(`span[order-sample-id='${fabricId}']`);
        if (item) {
            item.textContent = 'Added to Bag';
            item.classList.add('disabled');
        }
        // @ts-ignore
        await updateBasket();
        showNotification("Added to Wishlist");
    });

    useEffect(() => {
        fetchFabrics()
    }, []);

    const fetchFabrics  = async () => {
        setIsLoading(true)
        try {
            const response = await axios.get('/api/product/recently-view');
            setItems(response.data);
        } catch (error) {
            console.error('Error loading wishlist:', error);
        } finally {
            setIsLoading(false)
        }
    };

    const toggleAddedToWishlist = (fabricId) => {
        const url = `/api/wishlist/${fabricId}`;

        setItems(prevItems =>
            prevItems.map(item => {
                if (item.pkFabricID !== Number(fabricId)) return item;

                const newInWishlist = !item.inWishlist;
                const request = newInWishlist ? axios.post(url) : axios.delete(url);

                request.catch(error =>
                    console.error(newInWishlist ? 'Error adding to wishlist:' : 'Error removing from wishlist:', error)
                );

                return { ...item, inWishlist: newInWishlist };
            })
        );
    };

    const removeFromRecentlyViewed = (fabricId) => {
        axios.delete(`/api/product/recently-view/${fabricId}`)
            .then(() => {
                setItems(items.filter(_ => _.pkFabricID !== fabricId))
            })
            .catch(error => console.error('Error adding to wishlist:', error))
    }

    return (
        <>
        <div className="mt-54 sm-mt-32">
            {items.length > 0 ? (
                items.map(item => <FabricItem
                    inWishlist={item.inWishlist}
                    toggleAddedToWishlist={toggleAddedToWishlist}
                    mode="recently view"
                    fabricUrl={item.fabricUrl}
                    collectionName={item.fabricCollectionName}
                    collectionUrl={item.collectionUrl}
                    displayPrice={item.displayPrice}
                    fullName={item.fabricFullName}
                    id={item.pkFabricID}
                    imagePath={item.imageFilePathName}
                    fabricInCart={item.inShoppingCart}
                    onRemove={removeFromRecentlyViewed}
                    orderSample={orderSample}
                    sampleInCart={item.sampleInShoppingCart}
                    samplesUnavailable={item.samplesUnavailable}
                    supplierId={item.pkFabricSupplierID}
                    supplySamples={item.supplySamples}
                    key={item.pkFabricID}
                />)
            ) : (<Empty isLoading={isLoading} mode={'recently view'} />)}
        </div>

        {modalData && (
                <div
                    className="overlay-with-box mobile-menu d-flex samples-overlay"
                    onClick={(e) => { if (e.target.classList.contains('samples-overlay')) setModalData(null); }}
                >
                    <div className="overlay-box active-group flex-column pb-70 fit-content black mobile-menu-container sm-px-12 react-overlay">
                        <div className="width-550 sm-max-w-100">
                            <div className="row mb-54 sm-mb-24">
                                <div className="col">
                                    <h3 className="default-text" dangerouslySetInnerHTML={{ __html: modalData.title || '' }}></h3>
                                </div>
                                <div className="col-auto">
                                    <span
                                        className="curtains-icon curtains-icon-close size-24 pointer"
                                        onClick={() => setModalData(null)}
                                    ></span>
                                </div>
                            </div>

                            <div className="body-text3" dangerouslySetInnerHTML={{ __html: modalData.text || '' }}></div>

                            {modalData.imageUrl && (
                                <img
                                    src={modalData.imageUrl}
                                    alt={modalData.title}
                                    className="mt-54 sm-mt-24"
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default RecentlyViewed